/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowAUpIcon16Light } from './ArrowAUpIcon16Light';
import { ArrowAUpIcon16Regular } from './ArrowAUpIcon16Regular';
import { ArrowAUpIcon16Solid } from './ArrowAUpIcon16Solid';
import { ArrowAUpIcon20Light } from './ArrowAUpIcon20Light';
import { ArrowAUpIcon20Regular } from './ArrowAUpIcon20Regular';
import { ArrowAUpIcon20Solid } from './ArrowAUpIcon20Solid';
import { ArrowAUpIcon24Regular } from './ArrowAUpIcon24Regular';
import { ArrowAUpIcon24Solid } from './ArrowAUpIcon24Solid';
import { ArrowAUpIcon32Regular } from './ArrowAUpIcon32Regular';
import { ArrowAUpIcon64Regular } from './ArrowAUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowAUpIcon16Light,
        regular: ArrowAUpIcon16Regular,
        solid: ArrowAUpIcon16Solid,
    },
    20: {
        light: ArrowAUpIcon20Light,
        regular: ArrowAUpIcon20Regular,
        solid: ArrowAUpIcon20Solid,
    },
    24: {
        regular: ArrowAUpIcon24Regular,
        solid: ArrowAUpIcon24Solid,
    },
    32: {
        regular: ArrowAUpIcon32Regular,
    },
    64: {
        regular: ArrowAUpIcon64Regular,
    },
};
export var ArrowAUpIcon = forwardRef('ArrowAUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
